import { isArray } from 'lodash-es'

class SerializedResponse {
  constructor (MODEL, resp) {
    this.MODEL = MODEL
    this.response = resp
    this.jsonCache = this._computeJsonCache()
  }

  // True if the data is a collection
  get isCollection () {
    return isArray(this.response.data)
  }

  // Returns true if `paginate_data` or `manually_paginate_data` was
  // used to serialize this data
  get isPaginated () {
    return !!this.response.pagination
  }

  // Only present if `paginate_data` or `manually_paginate_data` was
  // used to serialize this data. Otherwise, `undefined`
  get paginationData () {
    return this.response.pagination
  }

  // Return the raw data as it was passed in straight
  // from the API request
  get rawData () {
    return this.response
  }

  // Return the data wrapped in model objects
  get modelData () {
    return this.jsonCache
  }

  // Convert all of the model objects into vanilla objects
  get json () {
    if (this.isCollection) {
      return this.jsonCache.map(m => m.toJson())
    } else {
      return this.jsonCache.toJson()
    }
  }

  _computeJsonCache () {
    if (this.isCollection) {
       this.jsonCache = this.response.data.map(d => new this.MODEL(d, this.response.included))
    } else {
      this.jsonCache = new this.MODEL(this.response.data, this.response.included)
    }
    return this.jsonCache
  }
}

export default SerializedResponse
